export default __webpack_public_path__ + "static/media/cp_geo_mp.f4332866.svg";